import { ListMaintenanceState } from '@/types/store/configuration/listMaintenance';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { ErrorModel, LockModel } from '@/types';

export const state: ListMaintenanceState = {
  builtInListLock: {} as LockModel,
  extendingLock: false,
  errorMessage: '',
  componentName: '',
  errorModel: {} as ErrorModel
};

const namespaced: boolean = true;

export const listMaintenance = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
